import type { TranslationKey } from "@/localisation/types";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "../../ui/button";

export type DatevError = {
  type: string;
  title: string;
  detail: string;
  affected_elements: { name: string; reason: string }[];
};

type Props = {
  datevError: DatevError;
};

export const DatevErrorMessage = ({ datevError }: Props) => {
  const { t } = useTranslation();

  if (!datevError) {
    return <p>{t("server_errors.unknown")}</p>;
  }

  return (
    <>
      {datevError.detail && (
        <p className="whitespace-pre-line">
          <Trans
            i18nKey={
              `integrations.datev.errors.${datevError.detail
                .toLowerCase()
                .replace(/\s+/g, "_")}` as any
            }
            components={{ bold: <span className="font-semibold" /> }}
          />
        </p>
      )}
      {datevError.affected_elements &&
        datevError.affected_elements.length > 0 && (
          <div className="my-2">
            {datevError.affected_elements.map((element) => (
              <p key={element.name}>
                {element.name}:{" "}
                {
                  t(
                    `integrations.datev.errors.${element.reason
                      .toLowerCase()
                      .replace(/\s+/g, "_")}` as TranslationKey,
                  ) as string
                }
              </p>
            ))}
          </div>
        )}
      {datevError.type && (
        <Button
          className="underline font-semibold text-color-muted text-xs p-0"
          onClick={() => window.open(datevError.type, "_blank")}
          variant="link"
        >
          {datevError.type}
        </Button>
      )}
    </>
  );
};
